export enum CardType {
    GetStarted,
    Progress,
    Approved,
    Referred,
    Expired,
    Declined,
    OrderComplete,
    OutOfStock,
    Error,
    CLInsufficient,
    GenerationFailed,
    CounterOffer,
    Info,
    Paused,
    Blocked,
    Generated
}
